import React from 'react';

function CloseIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="none"
      viewBox="0 0 24 25"
      {...props}
    >
      <g>
        <path
          fill="#FF8A00"
          d="M13.293 12.49l6.356-6.377a.942.942 0 000-1.335.934.934 0 00-1.33 0l-6.282 6.378-6.43-6.378a.934.934 0 00-1.33 0 .942.942 0 000 1.335l6.43 6.378-6.356 6.378a.942.942 0 000 1.334c.148.149.443.297.665.297.222 0 .444-.074.665-.297l6.356-6.377 6.356 6.377c.147.149.443.297.665.297.221 0 .443-.074.665-.297a.942.942 0 000-1.334l-6.43-6.378z"
        ></path>
      </g>
    </svg>
  );
}

export default CloseIcon;
